import {useEffect, useState} from 'react'
import {Button, styled} from '@mui/material'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import {Texts} from 'appearance'
import PreviewImage from './PreviewImage'

const ImageUploader = ({
    accept,
    onChange,
    onUpload,
    url,
    showImage,
    label,
    i18n,
}) => {
    const [fileName, setFileName] = useState()
    const [previewUrl, setPreviewUrl] = useState()

    const handleChange = (event) => {
        const file = event.target.files?.[0]
        if (!file) return
        setFileName(file.name)
        const objectUrl = URL.createObjectURL(file)
        setPreviewUrl(objectUrl)
        onChange(file)
        onUpload?.(file)
    }

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl)
        }
    }, [previewUrl])

    return (
        <>
            <Wrapper>
                <SelectFileButton
                    component="label"
                    variant="outlined"
                    startIcon={<UploadFileIcon />}>
                    {i18n.t('form.selectFile')}
                    <VisuallyHiddenInput
                        type="file"
                        accept={accept || 'image/*'}
                        onChange={handleChange}
                    />
                </SelectFileButton>

                <FileName>{fileName ?? i18n.t('form.noFile')}</FileName>
            </Wrapper>

            <PreviewImage
                src={previewUrl || url}
                alt={label}
                showImage={showImage && !!(previewUrl || url)?.length}
            />
        </>
    )
}

export default ImageUploader

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
})

const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 16px;
`

const SelectFileButton = styled(Button)`
    font-size: 12px;
`

const FileName = styled(Texts.Text)`
    font-weight: 300;
    font-size: 14px;
`
